import { Pressable, View, Image, Text } from 'react-native';
import { styles } from '../../utils/styles';
import { colors } from '../../utils/colors';
import { days, months } from '../../utils/helper-functions';

const EventCard = ({ navigation, customEvent, eventType, changeMainactState }) => {
	const eventDate = new Date(`${customEvent.event_date}T${customEvent.event_time}`);
	const dateString = `${days[eventDate.getDay()]} d. ${eventDate.getDate()}/${months[eventDate.getMonth()]}/${eventDate.getFullYear()}`;
	const dayOnly = eventDate.getDate();
	const dayOfWeek = `${days[eventDate.getDay()]}`;
	const dateWithMonth = `${eventDate.getDate()}. ${months[eventDate.getMonth()]}`;
	let newString = customEvent.genres + '';
	customEvent.dateWithMonth = dateWithMonth;
	customEvent.fullYear = eventDate.getFullYear();
	newString = newString.split(',');
	newString = newString.map((genre) => genre.trim());
	customEvent.genres = newString;
	customEvent.img_small_custom = customEvent.img_big;
	customEvent.img_big_custom = customEvent.img_big;
	const imagesAmount = eventType === 'container' ? customEvent.actImages : 1;

	return (
		<Pressable
			style={({ pressed }) => [{ backgroundColor: pressed ? colors.greyBackground__pressed : colors.greyBackground }, eventType == 'main' || eventType == 'container' ? styles.event : styles.event_sub]}
			onPress={() => {
				changeMainactState
					? changeMainactState(customEvent.event_id)
					: navigation.navigate('Event', {
							customEvent,
					  });
			}}
		>
			<View style={{ flexDirection: 'row' }}>
				{imagesAmount.length === 4 ? (
					<View style={styles.image_container}>
						<Image style={styles.image_3} source={{ uri: customEvent.img_small_custom }} />
						<Image style={styles.image_3} source={{ uri: customEvent.img_small_custom }} />
						<Image style={styles.image_3} source={{ uri: customEvent.img_small_custom }} />
						<Image style={styles.image_3} source={{ uri: customEvent.img_small_custom }} />
					</View>
				) : imagesAmount.length === 3 ? (
					<View style={styles.image_container}>
						<Image style={styles.image_main} source={{ uri: imagesAmount[0] }} />
						<Image style={styles.image_support} source={{ uri: imagesAmount[1] }} />
						<Image style={styles.image_support_2} source={{ uri: imagesAmount[2] }} />
					</View>
				) : imagesAmount.length === 2 ? (
					<View style={styles.image_container}>
						<Image style={styles.image_main} source={{ uri: imagesAmount[0] }} />
						<Image style={styles.image_support} source={{ uri: imagesAmount[1] }} />
					</View>
				) : (
					<Image style={styles.image} source={{ uri: customEvent.img_small_custom }} />
				)}
				{/* {eventType == 'container' ? <Image style={styles.image} source={{ uri: customEvent.img_small_custom }} /> : <Image style={styles.image} source={{ uri: customEvent.img_small_custom }} />} */}

				{customEvent.price === 0 && customEvent.support_for === '0' ? <Text style={styles.free_text}>Gratis</Text> : <Text></Text>}
				<View style={styles.eventInformation}>
					{customEvent.artist.length <= 18 ? <Text style={styles.eventTitle}>{customEvent.artist}</Text> : <Text style={styles.eventTitle}>{customEvent.artist.slice(0, 18) + '..'}</Text>}
					<Text style={styles.eventAddress}>{customEvent.venue}</Text>
					{(customEvent.genres[0] + customEvent.genres[1] + customEvent.genres[2]).length < 24 ? (
						<View style={styles.eventGenres}>
							<Text style={[styles.eventGenre, { backgroundColor: colors.green }]}>{customEvent.genres[0]}</Text>
							<Text style={[styles.eventGenre, { backgroundColor: colors.purple }]}>{customEvent.genres[1]}</Text>
							<Text style={[styles.eventGenre, { backgroundColor: colors.yellowDark }]}>{customEvent.genres[2]}</Text>
						</View>
					) : (
						<View style={styles.eventGenres}>
							<Text style={[styles.eventGenre, { backgroundColor: colors.green }]}>{customEvent.genres[0]}</Text>
							<Text style={[styles.eventGenre, { backgroundColor: colors.purple }]}>{customEvent.genres[1]}</Text>
						</View>
					)}
				</View>
			</View>
			{eventType !== 'sub' ? (
				<View style={styles.eventDate}>
					<Text style={styles.eventTime}>{days[eventDate.getDay()]}</Text>
					<View style={styles.date_box}>
						<Text style={styles.eventWhen}>{dayOnly}.</Text>
						<Text style={styles.eventMonth}>{months[eventDate.getMonth()].slice(0, 3)}</Text>
					</View>
					<Text style={styles.eventTime}>{customEvent.event_time}</Text>
				</View>
			) : (
				<View></View>
			)}
		</Pressable>
	);
};

export default EventCard;
